import React, {Component} from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {getOne,addParticipant} from '../../actions/eventsActions';
import {Container,Row, Col,Button, Modal, ModalHeader, ModalBody,Alert} from 'reactstrap';
import {Link} from 'react-router-dom';
import Recaptcha from 'react-recaptcha';



class EventsPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            id : null,
            title : null,
            name : null,
            email : null,
            message : null,
            modal: false,
            recaptchaVerified: false,
            submitting: false,
        };
        this.recaptchaLoaded = this.recaptchaLoaded.bind(this);
        this.verifyCallback = this.verifyCallback.bind(this);
        this.toggle = this.toggle.bind(this);
    }

    recaptchaLoaded() {
        console.log('Recaptcha loaded successfully');
    }

    verifyCallback(response) {
        if (response) {
            this.setState({ recaptchaVerified: true });
        }
    }

    change = e =>{
        this.setState({
            [e.target.id] : e.target.value
        });
        
    };
   
    isDatePassed(dateToTest) {
      const currentDate = new Date();
      const dateTest = new Date(dateToTest);
  
      // Extraire l'année, le mois et le jour de la date actuelle
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth();
      const currentDay = currentDate.getDate();
  
      // Extraire l'année, le mois et le jour de la date à tester
      const testYear = dateTest.getFullYear();
      const testMonth = dateTest.getMonth();
      const testDay = dateTest.getDate();
      
      
  
      // Comparer les dates en ignorant l'heure
      return currentYear > testYear || 
             (currentYear === testYear && (currentMonth > testMonth || 
             (currentMonth === testMonth && currentDay > testDay)));
  }
  
  
    submit = e =>{
        e.preventDefault();
        let {addParticipant} = this.props
       
        const formData = {
            id: this.props.match.params.id,
            title: document.getElementById("event").value,
            dateStart: document.getElementById("datestart").value,
            dateEnd: document.getElementById("dateEnd").value,
            idOrganizer: document.getElementById("idOrganizer").value,
            name: this.state.name,
            email: this.state.email,
            message: this.state.message,
        };
        this.setState({ submitting: true });
        if (this.state.recaptchaVerified) {
          addParticipant(formData)
            .then(() => {
              this.setState({ submitting: false });
            })
            .catch(() => {
              this.setState({ submitting: false });
            });
        } else {
          this.setState({ recaptchaVerified: false, submitting: false });
        }
    }
  componentDidMount() {
    this.props.getOne(this.props.match.params.id);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }
  formatPrix = (prix) => {
  const prixNumber = typeof prix === 'string' ? parseFloat(prix) : prix;
  if (typeof prixNumber === 'number') {
    return parseFloat(prixNumber.toFixed(0));
  } else {
    return prix;
  }
};

  render() {

    let {fetching, data} = this.props.eventsPage;
    let {participation} = this.props.eventsParticipation;

    return (
      <div>
        {fetching ?
          null
          :
          <div>
            <Container fluid={true} className="bg-section1">
                <Container>
                  <Row>
                    <Col xs="12" md="8" lg="8">
                        <div className="column-left">
                            <h2 data-aos="fade-up">{data.title}</h2>
                            <div className="mt-3 mb-4" dangerouslySetInnerHTML={{__html: data.short_description}} />
                            <Link to={'#'} className="download mt-1 mr-3">
                              <i className="fas fa-download"></i>&nbsp;
                              Télécharger la version pdf
                            </Link>
                            <Link to={'#'} className="partage mt-1 mr-2">
                              <i className="fas fa-square-share-nodes"></i>&nbsp;Partager la formation
                            </Link>
                        </div>
                    </Col>
                    <Col xs="12" md="4" lg="4">
                        <div className="orange">
                            <p className="paragraphe">Cours pratique en présentiel ou en classe à distance</p>
                            <hr/>
                            <p className="duration">Date et durée :{data.nbr_duree}j</p>
                            <Row>
                                <Col lg="6" className="column1">
                                    <div className="date">
                                        <time>{data.date_start}</time><br/>
                                        <time>{data.date_end}</time>
                                        
                                    </div>
                                </Col>
                                <Col lg="6" className="column2">
                                    Réf: {data.reference}<br/>
                                    Prix: {this.formatPrix(data.price)} € HT
                                </Col>
                            </Row>
                            <p className="text-description"><i>Pauses-café et déjeuners offerts</i></p>
                            
                                
                            {this.isDatePassed(data.date_end) ? (
                              
                            <p className="session">La période d'inscription à cette session est close.</p>
                            ) : (
                              <div className="participer">
                              <Button color="primary" onClick={this.toggle}>Participer</Button>
                            </div>
                            )}
                            
                            <div className="nous-contacter"> 
                                <Link to="/cms/9-nous-contacter">Nous contacter</Link>
                            </div> 
                              <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                                  <ModalHeader toggle={this.toggle}>Pour vous participer à la formation. Complétez vos informations!</ModalHeader>
                                  <ModalBody>
                                    <form onSubmit={this.submit} id="form-data" >
                                        <input type="hidden" className="form-control nom my-2" id ="event" name="event" value={data.title} onChange={this.change}/>
                                        <input type="hidden" className="form-control nom my-2" id ="datestart" name="dateStart" value={data.date_start} onChange={this.change}/>
                                        <input type="hidden" className="form-control nom my-2" id ="dateEnd" name="dateEnd" value={data.date_end} onChange={this.change}/>
                                        <input type="hidden" className="form-control nom my-2" id ="idOrganizer" name="idOrganizer" value={data.id_events_organizer} onChange={this.change}/>
                                        <input type="text" className="form-control nom my-2" id ="name" name="name" placeholder="Nom ..." onChange={this.change} required />
                                        <input type="email" className="form-control email my-2" id ="email" name="email" placeholder="E-mail ..." onChange={this.change} required/>
                                        <textarea className="form-control message my-2" id ="message" name="message" onChange={this.change} required></textarea>
                                        <Recaptcha
                                          sitekey="6LcP5z4pAAAAAIDhHElH--sdYuF-7iJBaZTgnSME"
                                          render="explicit"
                                          onloadCallback={this.recaptchaLoaded}
                                          verifyCallback={this.verifyCallback}
                                          hl="fr"
                                        />
                                          <Button color="primary" className="mt-3" disabled={this.state.submitting}>
                                            {this.state.submitting ? 'Envoi en cours...' : 'Envoyer'}
                                          </Button>
                                       </form>
                                  </ModalBody>
                                    <div id="message">
                                        
                                        {participation.alerte === 1?
                                          <Alert color="success" className="mt-4 ml-4 mr-4">
                                            Votre information est envoyé avec succès
                                          </Alert>
                                          : null
                                        }
                                        {participation.alerte === 2?
                                          <Alert color="danger" className="mt-4 ml-4 mr-4">
                                            votre e-mail existe!
                                          </Alert>
                                          : null
                                        }
                                    </div>
                                </Modal>
                        </div> 
                    </Col>
                  </Row> 
                </Container>
            </Container>
            <Container fluid={true} className="bg-section2 my-4">
                <Container>
                    <Row>
                       {data.objectif
                       ? 
                          <Col xs="12" md="6" lg="6">
                             <h2 className="title2 mb-4"><span>Objectifs pédagogiques</span></h2>
                             <p dangerouslySetInnerHTML={{__html: data.objectif}} />
                          </Col>
                       : null
                       }
                       {data.concerned_public 
                       ? 
                          <Col xs="12" md="6" lg="6">
                             <h2 className="title2 mb-4"><span>Public concerné</span></h2>
                             <p dangerouslySetInnerHTML={{__html: data.concerned_public}} />
                          </Col>
                       : null
                       }
                    </Row>

                    <Row>
                       {data.prerequis
                       ? 
                          <Col xs="12" md="6" lg="6">
                             <h2 className="title2 mb-4"><span>Prérequis</span></h2>
                             <p dangerouslySetInnerHTML={{__html: data.prerequis}} />
                          </Col>
                       : null
                       }
                       {data.evaluation_methods 
                       ? 
                          <Col xs="12" md="6" lg="6">
                             <h2 className="title2 mb-4"><span>Modalités d'évaluation</span></h2>
                             <p dangerouslySetInnerHTML={{__html: data.evaluation_methods}} />
                          </Col>
                       : null
                       }
                    </Row>
                    <Row>
                       {data.pratical
                       ? 
                          <Col xs="12" md="6" lg="6">
                             <h2 className="title2 mb-4"><span>Modalités pratiques</span></h2>
                             <p dangerouslySetInnerHTML={{__html: data.pratical}} />
                          </Col>
                       : null
                       }
                       {data.solution 
                       ? 
                          <Col xs="12" md="6" lg="6">
                             <h2 className="title2 mb-4"><span>Solutions de financement</span></h2>
                             <p dangerouslySetInnerHTML={{__html: data.solution}} />
                          </Col>
                       : null
                       }
                    </Row>
                    {data.accessibility 
                    ? 
                        <Row>
                           <Col xs="12" md="6" lg="6">
                              <h2 className="title2 mb-4"><span>Accessibilité aux personnes handicapées</span></h2>
                              <p dangerouslySetInnerHTML={{__html: data.accessibility}} />
                           </Col>
                           <Col xs="12" md="6" lg="6"></Col>
                      </Row>
                    : null
                    }
                </Container>
            </Container>
            <Container fluid={true} className="bg-section3">
                <Container className="programme">
                    <div className="losange" data-aos="fade-up">
                        <h3>Programme de la formation</h3>
                    </div>
                    <p className="border-vertical" dangerouslySetInnerHTML={{__html: data.programme}} />
                </Container>
            </Container>
            <Container fluid={true} className="bg-section4">
                <Container>
                <h4 data-aos="fade-up"><span>Horaires</span></h4>
                    <Row>
                        <Col xs="12" md="4" lg="4">
                            <p>En présentiel, les cours ont lieu de 9h à 12h30 et de 14h à 17h30.</p>
                            <p>Les participants sont accueillis à partir de 8h45. Les pauses et déjeuners sont offerts.</p>
                        </Col>
                        <Col xs="12" md="4" lg="4" className="ligne-vertical">
                            <p>En classe à distance, la formation démarre à partir de 9h.</p>
                        </Col>
                        <Col xs="12" md="4" lg="4" className="ligne-vertical">
                            <p>Pour les stages pratiques de 4 ou 5 jours, quelle que soit la modalité, les sessions se terminent à 15h30 le dernier jour.</p>
                        </Col>
                    </Row>
                </Container>
            </Container>
          </div>
        }
      </div>
    )
  }
}


function mapStateToProps({eventsReducer}) {
  return {
    eventsPage: eventsReducer.page,
    eventsParticipation: eventsReducer,

  }
}

function mapDispatchToProps(dispatch) {
  return {
    getOne: bindActionCreators(getOne, dispatch),
    addParticipant: bindActionCreators(addParticipant, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EventsPage);


// WEBPACK FOOTER //
// ./src/components/events/EventsPage.js